import { useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'form',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'create_task',
    })
  }
}

export function isDisabled(task) {
  return (
    !task.board_id ||
    !task.stage_id ||
    !task.title ||
    !task.priority ||
    (task.action?.id && !task.action.document_template)
  )
}
